import styled from 'styled-components';

export const Container = styled.div`
  display: block;
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background: var(--color-gray-700);

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 14px;
`;
export const Title = styled.span`
  display: flex;
  flex: 1;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: var(--color-white);
`;

export const SearchInput = styled.input`
  box-sizing: border-box;
  background: var(--color-white);
  border-radius: 8px;
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  padding: 14px 45px 14px 15px;
  z-index: 10;
`;
export const SearchInputContainer = styled.div`
  box-sizing: border-box;
  padding: 8px 16px;
  width: 100%;
  position: relative;
`;

export const IconContainer = styled.div`
  position: absolute;
  right: 20px;
  z-index: 999;
  margin: 18px 21px;
  cursor: pointer;
`;
